<template>
  <div>
    <div class="">
      <b-tabs lazy fill Justified @activate-tab="changeTab">
        <b-tab title="Công việc Sale">
          <sale></sale>
        </b-tab>
        <b-tab title="Công việc AFS">
          <afs></afs>
        </b-tab>
        <b-tab title="Công việc CSKH" :active="activeTab">
          <cskh></cskh>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
  import sale from './sale.vue'
  import afs from './afs.vue'
  import cskh from './cskh.vue'
  export default {
    name: 'STICKER_STANDEE',
    computed: {
      activeTab() {
        return this.$route.query.tab === '2' || 0
      },
    },
    methods: {
      changeTab(tab) {
        this.$router.push({ query: { tab: tab } })
      },
    },
    components: { sale, afs, cskh },
  }
</script>
